export const UPDATE_AD_SOURCE = 'UPDATE_AD_SOURCE';

export const updateAdSource = (payload: string) => ({
    type: UPDATE_AD_SOURCE,
    payload,
});

export default (state = '' as string, action: ReturnType<typeof updateAdSource>) =>
    action.type === UPDATE_AD_SOURCE ? action.payload : state;
